export const simulationFields = ['fatores', 'limites', 'seguradora', 'valor_taxa_mes']

export const debitBalance = ['limites']
